export const furanoseHexose = `
Actelion Java MolfileCreator 1.0

  8  8  0  0  0  0  0  0  0  0999 V2000
   18.2772  -13.5216    0.0000 C   0  0  0  0  0  0  0  0  0  1  0  0
   18.2772  -15.0216    0.0000 C   0  0  0  0  0  0  0  0  0  2  0  0
   19.7037  -15.4851    0.0000 C   0  0  0  0  0  0  0  0  0  3  0  0
   20.5854  -14.2716    0.0000 C   0  0  0  0  0  0  0  0  0  4  0  0
   19.7037  -13.0580    0.0000 O   0  0  0  0  0  0  0  0  0  5  0  0
   22.0855  -14.2716    0.0000 O   0  0  0  0  0  0  0  0  0  6  0  0
   17.0636  -12.6399    0.0000 C   0  0  0  0  0  0  0  0  0  7  0  0
   21.2664  -15.6081    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  1  1  0  0  0  0
  4  6  1  0  0  0  0
  1  7  1  0  0  0  0
  4  8  1  0  0  0  0
M  STY  1   1 DAT
M  SLB  1   1   1
M  SAL   1  1   1
M  SDT   1 NOSEARCH_OCL_CUSTOM_LABEL
M  SDD   1    18.2772   13.5216    DA    ALL  1       5
M  SED   1 5
M  STY  1   2 DAT
M  SLB  1   2   2
M  SAL   2  1   2
M  SDT   2 NOSEARCH_OCL_CUSTOM_LABEL
M  SDD   2    18.2772   15.0216    DA    ALL  1       5
M  SED   2 4
M  STY  1   3 DAT
M  SLB  1   3   3
M  SAL   3  1   3
M  SDT   3 NOSEARCH_OCL_CUSTOM_LABEL
M  SDD   3    19.7037   15.4851    DA    ALL  1       5
M  SED   3 3
M  STY  1   4 DAT
M  SLB  1   4   4
M  SAL   4  1   4
M  SDT   4 NOSEARCH_OCL_CUSTOM_LABEL
M  SDD   4    20.5854   14.2716    DA    ALL  1       5
M  SED   4 2
M  STY  1   5 DAT
M  SLB  1   5   5
M  SAL   5  1   7
M  SDT   5 NOSEARCH_OCL_CUSTOM_LABEL
M  SDD   5    17.0636   12.6399    DA    ALL  1       5
M  SED   5 6
M  STY  1   6 DAT
M  SLB  1   6   6
M  SAL   6  1   8
M  SDT   6 NOSEARCH_OCL_CUSTOM_LABEL
M  SDD   6    21.2664   15.6081    DA    ALL  1       5
M  SED   6 1
M  END
`;
//# sourceMappingURL=furanoseHexose.js.map